/**
 * Use the CSS tab above to style your Element's container.
 */
import React from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import messages from "i18n/messages";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      padding: "10px 12px",
      color: "#32325d",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
    },
  },
};

function CardSection({ setStatus, customer, paymentData, clientSecret, org }) {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    setStatus({ loading: true });
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) return;

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name: `${customer.firstname} ${customer.lastname}`,
        },
      },
    });
    if (result.error) {
      setStatus({
        status: "error",
        error: result.error.message,
        loading: false,
      });
      return;
    }

    const hostname = `${window.location.protocol}//${window.location.host}`;
    const return_url = `${hostname}/${org.odn}/status?payment_intent=${paymentData.payment_intent_id}`;
    window.location.href = return_url;
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={classNames({ loading: status.loading })}
      style={{ width: "100%" }}
    >
      <h3>
        <FormattedMessage {...messages.cardDetails} />
      </h3>
      <CardElement options={CARD_ELEMENT_OPTIONS} />
      <button className="btn btn-primary btn-rounded">
        <FormattedMessage {...messages.buyNow} />
      </button>
    </form>
  );
}

export default CardSection;

